import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../setup";

// Define a service using a base URL and expected endpoints
export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (payload) => {
        return {
          url: `/order/create`,
          method: "POST",
          body: { ...payload },
        };
      },
    }),
    makeOrderCompleted: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `/order/${id}`,
          method: "PATCH",
          body: { completed: true },
        };
      },
    }),
    deleteOrder: builder.mutation({
      query: ({ id, subdomain }) => {
        return {
          url: `/order/${id}`,
          method: "DELETE",
          params: { university_subdomain: subdomain },
        };
      },
    }),
    getOrdersHistory: builder.query({
      query: ({ userId }) => {
        return {
          url: `/order/history/${userId}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useMakeOrderCompletedMutation,
  useGetOrdersHistoryQuery,
} = orderApi;
